<template>
  <div class="coreStrengths">
    <div class="coreStrengths_title">亮点与优势</div>
    <div class="coreStrengths_one">
      <div class="coreStrengths_content">
        <ul>
          <li>
            <video
              controls
              src="https://ar-scene-source.nosdn.127.net/69393e59bb68ae1e4b5347bb7ea3a361.mp4"
              poster="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/gps.png"
            ></video>
          </li>
          <li>
            <p>技术与创意的深度融合</p>
            <p>
              依托深厚技术实力，深度融合多媒体与AR/VR等前沿科技，铸就核心竞争力。
            </p>
            <p>了解更多</p>
          </li>
        </ul>
      </div>
      <div class="coreStrengths_content2">
        <ul>
          <li>
            <video
              controls
              src="https://ar-scene-source.nosdn.127.net/4b95abc55a6b8b4af8aa1bdf307a8770.mp4"
              poster="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/reg.png"
            ></video>
          </li>
          <li>
            <p>业务领域广泛且聚焦前沿</p>
            <p>
              广域布局前沿赛道，以‘数字体验创新’为核心，打造由科技驱动的新锐互动体验.
            </p>
            <p>了解更多</p>
          </li>
        </ul>
      </div>
      <div class="coreStrengths_content">
        <ul>
          <li>
            <video
              controls
              src="https://ar-scene-source.nosdn.127.net/928d419f75948b8522d434abc40bfa9a.mp4"
              poster="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/zonemap.png"
            ></video>
          </li>
          <li>
            <p>强大的创意与落地能力</p>
            <p>
              以卓越创意驱动科技、艺术与内容融合；凭扎实技术实力实现超凡构想。
            </p>
            <p>了解更多</p>
          </li>
        </ul>
      </div>
      <div class="coreStrengths_content2">
        <ul>
          <li>
            <video
              controls
              src="https://ar-scene-source.nosdn.127.net/28229dbd92707582aea9125edc8c814e.mp4"
              poster="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/rendering.png"
            ></video>
          </li>
          <li>
            <p>丰富的标杆项目经验</p>
            <p>成功交付众多知名IP项目，彰显顶级客户合作力与广泛行业影响力。</p>
            <p>了解更多</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="coreStrengths_two">
      <ul>
        <li>
          <p
            @click="
              dialogTableVisible = true;
              payNumber = 0;
            "
          >
            播放视频
          </p>
          <p>查看更多</p>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/gps.png?imageView&thumbnail=340x190"
            alt=""
          />
          <span>AR定位跟踪</span>
          <span
            >融合双目相机和IMU测量信息，实现眼镜端6DoF追踪和实时Mesh重建，具备遮挡和碰撞特性。提供手势交互能力。提供虚实叠加录屏功能。可与易现EZXR的云定位服务连通，实现端云结合的高精度定位和追踪。</span
          >
        </li>
        <li>
          <p
            @click="
              dialogTableVisible = true;
              payNumber = 1;
            "
          >
            播放视频
          </p>
          <p>查看更多</p>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/reg.png?imageView&thumbnail=340x190"
            alt=""
          />
          <span>AI识别与交互</span>
          <span
            >以单目彩色/双目灰度作为输入，基于神经网络准确识别用户全自由度的手部姿态，移动端稳定实时。兼容性很好，两周即可让一款眼镜拥有双手交互的能力，目前手势交互SDK已落地于多家AR眼镜。</span
          >
        </li>
        <li>
          <p
            @click="
              dialogTableVisible = true;
              payNumber = 2;
            "
          >
            播放视频
          </p>
          <p>查看更多</p>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/zonemap.png?imageView&thumbnail=340x190"
            alt=""
          />
          <span>高精度空间建图</span>
          <span
            >拥有行业前沿的自研大空间三维建图能力，可满足室内外不同空间大小、多种场景类型、不同精度速度的建图定位需求；同时，借助深度学习神经网络和多种融合特征加持，可实现精准快速的秒级端云协同定位。</span
          >
        </li>
        <li>
          <p
            @click="
              dialogTableVisible = true;
              payNumber = 3;
            "
          >
            播放视频
          </p>
          <p>查看更多</p>
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/rendering.png?imageView&thumbnail=340x190"
            alt=""
          />
          <span>图像渲染引擎</span>
          <span
            >通过融合相机图像信息和IMU测量信息，实现高精度的设备运动跟踪和环境理解，感知其在空间的位置信息和环境中的平面等几何信息，并与之进行交互。支持在线地图构建和重定位，带来高性能的移动AR体验。</span
          >
        </li>
      </ul>
    </div>
    <el-dialog :visible.sync="dialogTableVisible" width="95%">
      <video
        controls
        :src="videoData[payNumber].date"
        :poster="videoData[payNumber].name"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      videoData: [
        {
          date: "https://ar-scene-source.nosdn.127.net/69393e59bb68ae1e4b5347bb7ea3a361.mp4",
          name: "https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/gps.png",
        },
        {
          date: "https://ar-scene-source.nosdn.127.net/4b95abc55a6b8b4af8aa1bdf307a8770.mp4",
          name: "https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/reg.png",
        },
        {
          date: "https://ar-scene-source.nosdn.127.net/928d419f75948b8522d434abc40bfa9a.mp4",
          name: "https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/zonemap.png",
        },
        {
          date: "https://ar-scene-source.nosdn.127.net/28229dbd92707582aea9125edc8c814e.mp4",
          name: "https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/rendering.png",
        },
      ],
      payNumber: 0,
    };
  },
};
</script>

<style lang="less">
@import url("@/statis/css/base.less");

.coreStrengths {
  width: 100%;
  height: auto;
  background: url("https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/bg01.png");

  &_two {
    display: none;
  }

  &_title {
    width: 100%;
    height: auto;
    font-size: 36px;
    font-weight: 400;
    color: #000;
    user-select: none;
    line-height: 10vw;
  }

  &_content {
    width: 100%;
    height: 26vw;
    position: relative;

    ul {
      width: 50%;
      height: 80%;
      position: absolute;
      left: 20%;

      li {
        &:nth-child(1) {
          width: 70%;
          height: 100%;

          video {
            width: 100%;
            height: 100%;
          }
        }

        &:nth-child(2) {
          width: 35%;
          height: auto;
          background: url("https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/bgright.png")
            no-repeat;
          position: absolute;
          right: 5%;
          top: 20%;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          align-items: start;

          p {
            &:nth-child(1) {
              box-sizing: border-box;
              padding: 30px;
              text-align: left;
              line-height: 10px;
              font-size: 14px;
              color: #000000e3;
              font-size: 28px;
            }

            &:nth-child(2) {
              box-sizing: border-box;
              padding: 30px;
              text-align: left;
              line-height: 30px;
              font-size: 14px;
              color: #555353e3;
            }

            &:nth-child(3) {
              box-sizing: border-box;
              padding: 30px;
              text-align: left;
              line-height: 10px;
              font-size: 18px;
              color: #555353e3;
              cursor: pointer;

              &:hover {
                color: #2439d8;
              }
            }
          }
        }
      }
    }
  }

  &_content2 {
    width: 100%;
    height: 26vw;
    position: relative;

    ul {
      width: 50%;
      height: 80%;
      position: absolute;
      right: 4%;

      li {
        &:nth-child(1) {
          width: 70%;
          height: 100%;

          video {
            width: 100%;
            height: 100%;
          }
        }

        &:nth-child(2) {
          width: 35%;
          height: auto;
          background: url("https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/bgright.png")
            no-repeat;
          background-size: 110% 110%;
          position: absolute;
          left: -25%;
          top: 20%;
          background-size: cover;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          align-items: start;

          p {
            &:nth-child(1) {
              box-sizing: border-box;
              padding: 30px;
              text-align: left;
              line-height: 10px;
              font-size: 14px;
              color: #000000e3;
              font-size: 28px;
            }

            &:nth-child(2) {
              box-sizing: border-box;
              padding: 30px;
              text-align: left;
              line-height: 30px;
              font-size: 14px;
              color: #555353e3;
            }

            &:nth-child(3) {
              box-sizing: border-box;
              padding: 30px;
              text-align: left;
              line-height: 10px;
              font-size: 18px;
              color: #555353e3;
              cursor: pointer;

              &:hover {
                color: #2439d8;
              }
            }
          }
        }
      }
    }
  }

  .el-dialog__wrapper {
    .el-dialog {
      background: none;
      box-shadow: none;

      video {
        width: 100%;
      }
    }
  }
}

@media (max-width: 1920px) {
  .coreStrengths {
    &_content {
      height: 36vw;

      ul {
        width: 70%;
        height: 80%;
        left: 5%;

        li {
          &:nth-child(2) {
            width: 50%;
            right: -10%;
          }
        }
      }
    }

    &_content2 {
      height: 36vw;
      overflow: hidden;

      ul {
        width: 70%;
        height: 80%;
        right: -13%;

        li {
          &:nth-child(2) {
            width: 50%;
            left: -40%;
          }
        }
      }
    }
  }
}

@media (max-width: 550px) {
  .coreStrengths {
    background: #fff;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 8vw;

    &_title {
      width: 100%;
      height: 25vw;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 6vw;
    }

    &_one {
      display: none;
    }

    &_two {
      display: block;
      width: 100%;
      height: auto;

      ul {
        width: 100%;
        height: auto;

        li {
          width: 100%;
          height: 100vw;
          position: relative;

          img {
            width: 100%;
            height: 43%;
            border-radius: 10px;
          }

          p {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            border: 1px solid rgb(255, 255, 255);
            border-radius: 5vw;
            background: rgba(41, 40, 40, 0.252);

            &:nth-child(1) {
              width: 30%;
              height: 8vw;
              top: 30%;
              left: 4%;
            }

            &:nth-child(2) {
              width: 30%;
              height: 8vw;
              top: 30%;
              left: 40%;
            }
          }

          span {
            display: block;
            text-align: left;

            &:nth-child(4) {
              font-size: 6vw;
              font-weight: bold;
              height: 15%;
              display: flex;
              align-items: center;
            }
            &:nth-child(5) {
              line-height: 7vw;
              color: #312f2fc5;
              font-size: 3.3vw;
            }
          }
        }
      }
    }
  }
}
</style>
